import { request } from './client';
import type { Square, SquareWithNumbers, ClaimSquareInput, AssignSquareInput, LabelSquareInput } from '../types';

export const squaresApi = {
  async getAll(boardId: string): Promise<SquareWithNumbers[]> {
    return request<SquareWithNumbers[]>(`/api/squareup/boards/${boardId}/squares`);
  },

  async claim(boardId: string, input: ClaimSquareInput): Promise<Square> {
    return request<Square>(`/api/squareup/boards/${boardId}/squares/claim`, {
      method: 'POST',
      body: input,
    });
  },

  async assign(boardId: string, input: AssignSquareInput): Promise<Square> {
    return request<Square>(`/api/squareup/boards/${boardId}/squares/assign`, {
      method: 'POST',
      body: input,
    });
  },

  async label(boardId: string, input: LabelSquareInput): Promise<Square> {
    return request<Square>(`/api/squareup/boards/${boardId}/squares/label`, {
      method: 'POST',
      body: input,
    });
  },

  async clear(boardId: string, row: number, col: number): Promise<Square> {
    return request<Square>(`/api/squareup/boards/${boardId}/squares/clear`, {
      method: 'POST',
      body: { row, col },
    });
  },

  async reset(boardId: string): Promise<void> {
    return request<void>(`/api/squareup/boards/${boardId}/squares/reset`, {
      method: 'POST',
    });
  },

  async autofillSquares(boardId: string, includeManager: boolean): Promise<Square[]> {
    return request<Square[]>(`/api/squareup/boards/${boardId}/squares/autofill`, {
      method: 'POST',
      body: { includeManager },
    });
  },
};
